import { useState, useEffect, useCallback } from 'react'
import guidesDataEs from './guidesData-es.json'
import guidesDataPt from './guidesData-pt.json'
import AssessmentApi from '../../API/Assessment'
import { IoIosArrowBack, IoIosArrowDown } from 'react-icons/io'
import { useIntl } from 'react-intl'
import { MdWork } from 'react-icons/md'
import Loading from '../Loading/Loading'
import { developmentGuideTranslate } from '../../i18n/translatedMessages'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import PDFButtonDevelopmentGuide from '../PDFDevelopmentGuide/pdfDevelopmentGuide'

const titleTranslations = {
	'Trabajo en Equipo': 'Trabalho em Equipe',
	'Comunicación efectiva': 'Comunicação Eficaz',
	'Relaciones interpersonales': 'Relações Interpessoais',
	'Orientación a resultados': 'Orientação para Resultados',
	'Inclusión y Diversidad': 'Inclusão e Diversidade',
	'Empatía': 'Empatia',
	'Autoconocimiento': 'Autoconhecimento',
	'Balance de Vida Personal-Laboral': 'Equilíbrio entre Vida Pessoal e Profissional',
	'Aprendizaje continuo': 'Aprendizado Contínuo',
	'Flexibilidad': 'Flexibilidade',
	'Resiliencia': 'Resiliência',
	'Visión inspiradora': 'Visão Inspiradora',
	'Entrenamiento de líderes': 'Treinamento de Líderes',
	'Gestión del cambio': 'Gestão da Mudança',
	'Toma de decisiones': 'Tomada de Decisões',
	'Orientación al cliente': 'Orientação ao Cliente',
	'Creatividad e Innovación': 'Criatividade e Inovação',
	'Pensamiento Estratégico': 'Pensamento Estratégico',
	'Gestión eficaz del tiempo': 'Gestão Eficaz do Tempo',
	'Negociación efectiva': 'Negociação Eficaz',
}

export function GuideView({ employee, onCloseResult, language, employeeView }) {
	console.log('GuideView: ', employee)
	const [currentGuideIndex, setCurrentGuideIndex] = useState(0)
	const [guides, setGuides] = useState([])
	const [userData, setUserData] = useState([])
	const [loading, setLoading] = useState(false)

	const getData = useCallback(async () => {
		try {
			setLoading(true)
			const response = await AssessmentApi.getEmployeeSkills(employee.id)
			console.log('Response: ', response)
			setUserData(response)
		} catch {
		} finally {
			setLoading(false)
		}
	}, [language, employee])

	useEffect(() => {
		getData()
	}, [getData])

	useEffect(() => {
		if (userData.length > 0) {
			const skillNames = userData.map(item => item.assessmentSkills?.name?.toLowerCase())

			const filteredGuidesEs = guidesDataEs.filter(guide => skillNames.includes(guide.title.toLowerCase()))

			const filteredGuidesPt = guidesDataPt.filter(guide => {
				const translatedTitleEs = Object.keys(titleTranslations).find(
					esTitle => titleTranslations[esTitle]?.toLowerCase() === guide.title.toLowerCase()
				)

				return filteredGuidesEs.some(esGuide => esGuide.title.toLowerCase() === translatedTitleEs?.toLowerCase())
			})

			const orderedGuides = skillNames
				.map(skillName => {
					if (language === 'pt') {
						return filteredGuidesPt.find(guide => {
							const translatedTitleEs = Object.keys(titleTranslations).find(
								esTitle => titleTranslations[esTitle]?.toLowerCase() === guide.title.toLowerCase()
							)
							return translatedTitleEs?.toLowerCase() === skillName
						})
					} else {
						return filteredGuidesEs.find(guide => guide.title.toLowerCase() === skillName)
					}
				})
				.filter(guide => guide !== undefined)

			setGuides(orderedGuides)
		}
	}, [userData, language])

	const currentGuide = guides[currentGuideIndex]

	if (loading) return <Loading />

	return (
		<>
			{!employeeView && (
				<div className='tw-flex tw-space-x-4 tw-mb-4 tw-items-center'>
					<button
						onClick={onCloseResult}
						className='tw-rounded-full tw-text-purple-500 tw-p-1 tw-w-[32px] tw-h-[32px] tw-bg-white hover:tw-bg-purple-500 hover:tw-text-white tw-flex tw-items-center tw-justify-center border border-primary'
					>
						<IoIosArrowBack />
					</button>
					<div className='tw-font-bold tw-text-2xl'>{employee.name}</div>
					<div className='tw-text-purple-500 tw-flex tw-items-center'>
						<MdWork size={18} className='tw-mr-1' />
						{employee.jobName}
					</div>
					{/* <div className='tw-text-gray-500 tw-flex tw-items-center'>
					<MdEmail size={18} className='tw-mr-1' />
					{employee.email ?? '-'}
				</div> */}
				</div>
			)}

			<div className='tw-bg-white border tw-p-6 tw-rounded-lg tw-shadow-md tw-space-y-10 tw-mr-15'>
				{guides.length > 0 ? (
					<>
						{employeeView ? (
							<div>
								<div>{developmentGuideTranslate.developmentGuideText1EE}</div>
								<div className='tw-mt-4'>{developmentGuideTranslate.developmentGuideText2EE}</div>
							</div>
						) : (
							<div>
								<div>{developmentGuideTranslate.developmentGuideText1}</div>
								<div className=' tw-mt-4'>{developmentGuideTranslate.developmentGuideText2}</div>
							</div>
						)}
						<div className='2xl:tw-hidden tw-flex tw-justify-end'>
							<div className='tw-w-60'>
								<PDFButtonDevelopmentGuide userData={guides} employeeName={employee.name} content={userData} language={language} />
							</div>
						</div>
						<div className='2xl:tw-flex 2xl:tw-justify-between tw-items-center'>
							<div className='tw-space-x-2 tw-bg-gray-50 tw-p-2 tw-rounded-full tw-inline-flex'>
								{guides.map((guide, index) => (
									<div
										key={index}
										className={`tw-text-sm tw-items-center tw-justify-center tw-flex desktop:tw-text-base tw-cursor-pointer tw-px-4 tw-py-2 tw-rounded-full tw-shadow-md ${
											currentGuideIndex === index ? 'tw-bg-white tw-text-black tw-font-medium' : 'tw-bg-gray-100 tw-text-gray-600'
										}`}
										onClick={() => setCurrentGuideIndex(index)}
									>
										{guide.title}
									</div>
								))}
							</div>

							<div className='2xl:tw-w-1/5 tw-hidden 2xl:tw-block'>
								<PDFButtonDevelopmentGuide userData={guides} employeeName={employee.name} content={userData} language={language} />
							</div>
						</div>

						<div>
							<div className='tw-text-lg tw-font-semibold tw-text-gray-800 tw-mb-4'>Sobre</div>
							<div className='tw-text-gray-600'>{currentGuide.description}</div>
						</div>

						<div className='tw-space-y-2'>
							{currentGuide.tags.map((tag, index) => (
								<div key={index} className='tw-flex tw-space-x-2 tw-items-center'>
									<div
										className={`tw-px-3 tw-py-1 tw-rounded-full tw-inline-block ${
											index === 1 ? 'tw-bg-green-100 tw-text-green-600' : 'tw-bg-blue-100 tw-text-blue-600'
										}`}
										style={{ minWidth: 'fit-content', whiteSpace: 'nowrap' }}
									>
										{tag.title}
									</div>
									<div>{tag.desc}</div>
								</div>
							))}
						</div>

						<div>
							<div className='tw-text-lg tw-font-semibold tw-text-gray-800 tw-mb-4'>{developmentGuideTranslate.devGuideIndicators}</div>
							<ul className='tw-space-y-4 tw-pl-0 tw-text-gray-600'>
								{currentGuide.indicators.map(indicator => (
									<li key={indicator.id} className='tw-flex tw-items-start tw-space-x-3'>
										<div className='tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-bg-gray-50 tw-rounded-full tw-text-gray-600'>
											{indicator.id}
										</div>
										<div>
											<div className='tw-font-semibold'>{indicator.title}</div>
											<p className='tw-text-gray-600'>{indicator.description}</p>
										</div>
									</li>
								))}
							</ul>
						</div>

						<div>
							<h3 className='tw-text-lg tw-font-semibold tw-text-gray-800 tw-mb-4'>{developmentGuideTranslate.devGuideTools}</h3>
							<ul className='tw-space-y-4 tw-pl-0'>
								{currentGuide.tools.map(tool => (
									<li key={tool.id} className='tw-flex tw-items-start tw-space-x-3'>
										<div className='tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-bg-gray-50 tw-rounded-full tw-text-gray-600'>
											{tool.id}
										</div>
										<div>
											<div className='tw-font-semibold'>{tool.title}</div>
											<p className='tw-text-gray-600'>{tool.description}</p>
										</div>
									</li>
								))}
							</ul>
						</div>

						<div>
							<h3 className='tw-text-lg tw-font-semibold tw-text-gray-800 tw-mb-4'>{developmentGuideTranslate.devGuideChallenges}</h3>
							<ul className='tw-space-y-4 tw-pl-0'>
								{currentGuide.dailyChallenges.map(challenge => (
									<li key={challenge.id} className='tw-flex tw-items-start tw-space-x-3'>
										<div className='tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-bg-gray-50 tw-rounded-full tw-text-gray-600'>
											{challenge.id}
										</div>
										<div>
											<div className='tw-font-semibold'>{challenge.title}</div>
											<p className='tw-text-gray-600'>{challenge.description}</p>
										</div>
									</li>
								))}
							</ul>
						</div>

						<Accordion content={userData[currentGuideIndex].assessmentSkills.content[0]} />
						<div className='tw-w-full'>
							<PDFButtonDevelopmentGuide userData={guides} employeeName={employee.name} content={userData} language={language} />
						</div>
					</>
				) : (
					<div className='tw-text-center tw-text-gray-600'>
						{developmentGuideTranslate.developmentGuideEmpty}
						<Link to='/employee/assessment' className='tw-text-blue-500 hover:tw-underline tw-font-semibold'>
							{' '}
							{developmentGuideTranslate.developmentGuideEELink}
						</Link>
					</div>
				)}
			</div>
		</>
	)
}

const Accordion = ({ content }) => {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'
	const [openIndex, setOpenIndex] = useState(null)
	const [loading, setLoading] = useState(false)

	const handleAccordionClick = index => {
		if (!loading) setOpenIndex(prevIndex => (prevIndex === index ? null : index))
	}

	return (
		<div className='border tw-rounded-lg tw-shadow-sm'>
			{/* Accordion for Books */}
			{content.books && content.books.length > 0 && (
				<div>
					<div
						onClick={() => handleAccordionClick(0)}
						className={`tw-w-full tw-text-left tw-flex tw-items-center tw-p-4 tw-h-[60px] border-bottom tw-cursor-pointer ${
							openIndex === 0 ? 'tw-bg-purple tw-text-white' : 'tw-bg-white'
						}`}
					>
						<span className='tw-flex-1'>{developmentGuideTranslate.devGuideBooks}</span>
						<IoIosArrowDown className={`tw-transform ${openIndex === 0 ? 'tw-rotate-180' : ''}`} />
					</div>
					{openIndex === 0 && (
						<div className='tw-px-4 tw-py-2  border-bottom '>
							<ul>
								{content.books.map((book, i) => (
									<li key={i} className='tw-mb-2 tw-text-gray-600'>
										{book}
									</li>
								))}
							</ul>
						</div>
					)}
				</div>
			)}

			{/* Accordion for Movies */}
			{content.movies && content.movies.length > 0 && (
				<div>
					<div
						onClick={() => handleAccordionClick(1)}
						className={`tw-w-full tw-text-left tw-flex tw-items-center tw-p-4 tw-h-[60px] border-bottom tw-cursor-pointer ${
							openIndex === 1 ? 'tw-bg-purple tw-text-white' : 'tw-bg-white'
						}`}
					>
						<span className='tw-flex-1'>{developmentGuideTranslate.devGuideMovies}</span>
						<IoIosArrowDown className={`tw-transform ${openIndex === 1 ? 'tw-rotate-180' : ''}`} />
					</div>
					{openIndex === 1 && (
						<div className='tw-px-4 tw-py-2  border-bottom '>
							<ul>
								{content.movies.map((movie, i) => (
									<li key={i} className='tw-mb-2 tw-text-gray-600'>
										{movie[3] ? movie : 'Outra solucao'}
										{movie[1] ?? 'Sem dados'}
									</li>
								))}
							</ul>
						</div>
					)}
				</div>
			)}

			{/* Accordion for Videos */}
			{content.videos && (
				<div>
					<div
						onClick={() => handleAccordionClick(2)}
						className={`tw-w-full tw-text-left tw-flex tw-items-center tw-p-4 tw-h-[60px] border-bottom tw-cursor-pointer ${
							openIndex === 2 ? 'tw-bg-purple tw-text-white' : 'tw-bg-white'
						}`}
					>
						<span className='tw-flex-1'>{developmentGuideTranslate.devGuideVideos}</span>
						<IoIosArrowDown className={`tw-transform ${openIndex === 2 ? 'tw-rotate-180' : ''}`} />
					</div>
					{openIndex === 2 && (
						<div className='tw-px-4 tw-py-2 border-bottom'>
							<div>
								{content.videos[language === 'pt' ? 'pt_br' : 'es'] && content.videos[language === 'pt' ? 'pt_br' : 'es'].length > 0 && (
									<div>
										<ul>
											{content.videos[language === 'pt' ? 'pt_br' : 'es'].map((video, i) => (
												<li key={i}>
													<a href={video.url} target='_blank' rel='noopener noreferrer'>
														{video.title}
													</a>
												</li>
											))}
										</ul>
									</div>
								)}
							</div>
						</div>
					)}
				</div>
			)}

			{/* Accordion for Courses */}
			{content.courses && (
				<div>
					<div
						onClick={() => handleAccordionClick(3)}
						className={`tw-w-full tw-text-left tw-flex tw-items-center tw-p-4 tw-h-[60px] border-bottom tw-cursor-pointer ${
							openIndex === 3 ? 'tw-bg-purple tw-text-white' : 'tw-bg-white'
						}`}
					>
						<span className='tw-flex-1'>Cursos</span>
						<IoIosArrowDown className={`tw-transform ${openIndex === 3 ? 'tw-rotate-180' : ''}`} />
					</div>
					{openIndex === 3 && (
						<div className='tw-px-4 tw-py-2 border-bottom'>
							<div>
								{content.courses[language === 'pt' ? 'pt_br' : 'es'] && content.courses[language === 'pt' ? 'pt_br' : 'es'].length > 0 && (
									<div>
										<ul>
											{content.courses[language === 'pt' ? 'pt_br' : 'es'].map((course, i) => (
												<li key={i}>
													<a href={course.url} target='_blank' rel='noopener noreferrer'>
														{course.title}
													</a>
												</li>
											))}
										</ul>
									</div>
								)}
							</div>
						</div>
					)}
				</div>
			)}

			{/* Accordion for TED Talks */}
			{content.ted_talkings && (
				<div>
					<div
						onClick={() => handleAccordionClick(4)}
						className={`tw-w-full tw-text-left tw-flex tw-items-center tw-p-4 tw-h-[60px] border-bottom tw-cursor-pointer ${
							openIndex === 4 ? 'tw-bg-purple tw-text-white' : 'tw-bg-white'
						}`}
					>
						<span className='tw-flex-1'>TED Talks</span>
						<IoIosArrowDown className={`tw-transform ${openIndex === 4 ? 'tw-rotate-180' : ''}`} />
					</div>
					{openIndex === 4 && (
						<div className='tw-px-4 tw-py-2 border-bottom'>
							<div>
								{content.ted_talkings[language === 'pt' ? 'pt_br' : 'es'] && content.ted_talkings[language === 'pt' ? 'pt_br' : 'es'].length > 0 && (
									<div>
										<ul>
											{content.ted_talkings[language === 'pt' ? 'pt_br' : 'es'].map((talk, i) => (
												<li key={i}>
													<a href={talk.url} target='_blank' rel='noopener noreferrer'>
														{talk.title}
													</a>
												</li>
											))}
										</ul>
									</div>
								)}
							</div>
						</div>
					)}
				</div>
			)}
		</div>
	)
}
